export const DefaultInstanceTemplateName: string = "Standard";